import { STAFF_SCOPE, type PlatformScope } from "@/domain/scope/platform-scope"
import { matchesPublicRoute } from "@/shared/config/public-routes"

/** Prefixes a spotlight never lands on, beside every public route. */
const EXCLUDED_PREFIXES: ReadonlyArray<string> = [
  "/onboarding",
  "/super-admin",
  "/prototypes",
  // The design preview, until phase 5 deletes it.
  "/feed/spotlight-redesign",
]

const under = (pathname: string, prefix: string): boolean =>
  pathname === prefix || pathname.startsWith(`${prefix}/`)

/**
 * Which surface a path is, for the queue, or null where no spotlight may show
 * (spec cova-feed/2026-10-09-001 §6.2): sign-in, sign-up, invitations and
 * public booking (the public-route list), onboarding, super-admin and the
 * prototypes. An embed never mounts the host (the root layout's embed branch).
 *
 * The surface only narrows which spotlights are eligible; it grants nothing.
 */
export function spotlightSurfaceFor(pathname: string): PlatformScope | null {
  if (matchesPublicRoute(pathname)) return null
  if (EXCLUDED_PREFIXES.some((prefix) => under(pathname, prefix))) return null
  if (under(pathname, "/cs")) return STAFF_SCOPE
  if (under(pathname, "/underwriter")) return "underwriter"
  return "insurance-broker"
}
